/**
 * Lightweight feature flags. Flip a value to enable/disable a feature
 * without ripping out the underlying code.
 */

// Explorer-facing "save passport" (bookmark in passport detail view, the
// /saved page and the hamburger link). Temporarily disabled while the
// saved-CVs backend flow is being fixed. Re-enable by setting to `true`.
export const ENABLE_SAVED_PASSPORTS = false;

/**
 * Explore sub-views inside the Explore tab. Community (Talks) and Creators
 * are temporarily hidden from the world switcher; old ?view=community|creators
 * links and /community routes fall back to Passports (cvs).
 */
export const EXPLORE_COMMUNITY_ENABLED = false;
export const EXPLORE_CREATORS_ENABLED = false;

/**
 * Explorer Job Radar (`?tab=watch`). Paused to cut Azure spend
 * (ceveev1-job-watcher + jw-* cron jobs). Code and admin hub stay;
 * flip to `true` and scale the container app back up to revive.
 */
export const JOB_RADAR_ENABLED = false;

export type ExploreViewId = 'cvs' | 'community' | 'creators';

export const getVisibleExploreViews = (): ExploreViewId[] => {
  const views: ExploreViewId[] = ['cvs'];
  if (EXPLORE_COMMUNITY_ENABLED) views.push('community');
  if (EXPLORE_CREATORS_ENABLED) views.push('creators');
  return views;
};

export const normalizeExploreView = (view: string | null): ExploreViewId => {
  const visible = getVisibleExploreViews();
  return view && visible.includes(view as ExploreViewId) ? (view as ExploreViewId) : 'cvs';
};

/**
 * Recruiter B2B sidebar shell (RecruiterShell). Replaces the per-page
 * pill / sub-header nav with a professional left sidebar on recruiter routes.
 *
 * LIVE (default ON): recruiter pages hide their in-page pill/sub-header nav
 * and use the sidebar instead. Roll back instantly by flipping the default to
 * `false`, or per-device via:
 *   localStorage.setItem('cevee_recruiter_shell', '0')  // force off
 *   localStorage.setItem('cevee_recruiter_shell', '1')  // force on
 */
const RECRUITER_SHELL_DEFAULT = true;

export const isRecruiterShellEnabled = (): boolean => {
  try {
    const override = localStorage.getItem('cevee_recruiter_shell');
    if (override === '1') return true;
    if (override === '0') return false;
  } catch {
    /* ignore (private mode / disabled storage) */
  }
  return RECRUITER_SHELL_DEFAULT;
};
